var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fcfcfc;opacity:0;}.b{fill:none;stroke:#388cff;stroke-linecap:round;stroke-linejoin:round;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.29 2.499)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 10.833,
    transform: "translate(5.377 2.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 10.833,
    transform: "translate(5.377 7.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 10.833,
    transform: "translate(5.377 12.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 0.008,
    transform: "translate(1.21 2.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 0.008,
    transform: "translate(1.21 7.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 0.008,
    transform: "translate(1.21 12.501)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewIcon);
export default __webpack_public_path__ + "static/media/list-view-icon.2a56bca6869ded85c40d9a35c704c7b5.svg";
export { ForwardRef as ReactComponent };